// extracted by mini-css-extract-plugin
export default {"container":"fYOJm","textContainer":"GYDxc","title":"Cjljx","description":"drC_n","closeButton":"ONgij","asset":"sbnMM","logo":"cyzMD"};